import type { MailboxInfo } from 'owa-client-types';
import type SocialActivityNotificationPayload from 'owa-service/lib/contract/SocialActivityNotificationPayload';
import { action } from 'satcheljs';

export interface REACTION_NOTIFICATIONActionMessage {
    notification: SocialActivityNotificationPayload;
    mailboxInfo: MailboxInfo | undefined;
}
const defaultExport: (
    notification: SocialActivityNotificationPayload,
    mailboxInfo?: MailboxInfo
) => REACTION_NOTIFICATIONActionMessage = action(
    'REACTION_NOTIFICATION',
    (
        notification: SocialActivityNotificationPayload,
        mailboxInfo?: MailboxInfo
    ): REACTION_NOTIFICATIONActionMessage => ({
        notification,
        mailboxInfo,
    })
);
export default defaultExport;
